import { Navigate, useLocation } from "react-router-dom"

/** Редирект с сохранением query string и hash (для /search → /catalog/search и т.п.). */
export const PreserveSearchRedirect = ({ to }: { to: string }) => {
  const { search, hash } = useLocation()
  return <Navigate to={`${to}${search}${hash}`} replace />
}
